import { useMutation } from '@tanstack/react-query';
import { BusinessPlanSurvey } from '../types';
import useApi from '../../api/backendApiContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';

export const useUpdateSurveyMutation = () => {
  const { businessPlanApi } = useApi();
  const queryCacheManager = useQueryCacheManager();

  return useMutation({
    mutationFn: async (survey: BusinessPlanSurvey) =>
      businessPlanApi.updateBusinessPlanSurvey(survey),
    onMutate: (survey) => queryCacheManager.updateBusinessPlanSurvey(survey),
    onSuccess: (survey) => queryCacheManager.updateBusinessPlanSurvey(survey),
  });
};
